<nb-card class="spreadsheet-card">
  @if (loading) {
    <div class="grid-loading-overlay">
      <span class="ag-icon ag-icon-loading" role="presentation" unselectable="on"></span>
    </div>
  }
  <ag-grid-angular
    class="ag-theme-balham ag-grid-kpi"
    [gridOptions]="gridOptions"
    >
  </ag-grid-angular>
</nb-card>